import { getOrder } from "@commerce-os/contracts";
import { LoadingState } from "@commerce-os/ui";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import { useApp } from "../../../app/context";
import { useT } from "../../../app/i18n";
import { QueryError } from "../../../components/query-error";
import { OrderFormPage } from "../../../features/orders/order-form-page";
import { orderKey } from "../../../features/orders/queries";

export const Route = createFileRoute("/_app/orders/$id_/edit")({ component: EditOrderRoute });

function EditOrderRoute() {
  const { id } = Route.useParams();
  const { t } = useT();
  const { api } = useApp();
  const order = useQuery({
    queryKey: orderKey(id),
    queryFn: ({ signal }) => api.call(getOrder, { params: { id }, signal }),
  });
  if (order.isPending) return <LoadingState label={t("states.loading")} />;
  if (order.isError) return <QueryError error={order.error} onRetry={() => void order.refetch()} />;
  return <OrderFormPage key={`${id}:${String(order.data.version)}`} order={order.data} />;
}
